import { AxiosResponse } from "axios";

export const downloadFile = (blob: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName || 'download';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const base64StringToBlob = (data: string) => {
  const byteCharacters = atob(data);
  let bytes = new Uint8Array(byteCharacters.length);
  for (let i = 0; i < bytes.length; i++) {
    bytes[i] = byteCharacters.charCodeAt(i);
  }
  return new Blob([bytes]);
};

export const getDownloadFileName = (res: AxiosResponse): string | undefined => {
  const contentDisposition = res.headers['content-disposition'];
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="?(.+?)"?($|;)/);
    if (fileNameMatch && fileNameMatch[1]) {
      return fileNameMatch[1];
    }
  }
  return undefined;
};